import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import SupportWidget from "./components/feature/SupportWidget";
import { ThemeProvider } from "./contexts/ThemeContext";
import { AuthProvider } from "./contexts/AuthContext";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <AppRoutes />
          <SupportWidget />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
